// Orders the fields inside a section.
//
// We deliberately sort client-side instead of via a Firestore `.orderBy('SectionPosition')`:
// Firestore EXCLUDES documents that lack the field named in orderBy, so any existing
// in-section question without `SectionPosition` would silently disappear. Sorting here
// with a fallback chain (SectionPosition → Position → input order) lets us add
// `SectionPosition` without migrating old data.
//
// AI-CONTEXT: See docs/pitfalls.md#database-firestore-orderby-excludes-missing-field
const sortKey = (field) => {
    if (Number.isFinite(field?.SectionPosition)) return field.SectionPosition
    if (Number.isFinite(field?.Position)) return field.Position
    return Number.MAX_SAFE_INTEGER
}

const sortSectionFields = (fields) => {
    if (!Array.isArray(fields)) return []

    // copy first — Array.sort is in-place and stable, so ties keep input order
    return [...fields].sort((a, b) => sortKey(a) - sortKey(b))
}

export default sortSectionFields
